<template>
    <div class="settings-basic-info-page" v-loading="loading">
        <el-card shadow="never" class="settings-basic-info-page__card">
            <el-form label-width="100px">
                <el-form-item label="系统名称">
                    <el-input
                        v-model.trim="form.site_name"
                        maxlength="80"
                        show-word-limit
                        placeholder="留空则使用默认名称"
                        :disabled="!canEdit"
                        class="settings-basic-info-page__input-name"
                    />
                </el-form-item>

                <el-form-item label="当前 LOGO">
                    <div v-if="previewUrl" class="settings-basic-info-page__preview-wrap">
                        <img :src="previewUrl" alt="LOGO" class="settings-basic-info-page__preview" @error="onImgError">
                    </div>
                    <span v-else class="settings-basic-info-page__no-logo">未上传</span>
                </el-form-item>

                <el-form-item v-if="canEdit" label="上传/更换">
                    <input ref="fileInput" type="file" accept=".jpg,.jpeg,.png,.gif,.webp,.svg" @change="onFileChange">
                    <div v-if="pendingFileName" class="settings-basic-info-page__pending">{{ pendingFileName }}</div>
                </el-form-item>

                <el-form-item v-if="canEdit">
                    <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
                    <el-button :disabled="!hasLogoOnServer && !pendingFile" :loading="deleting" @click="handleDeleteLogo">删除 LOGO</el-button>
                </el-form-item>

                <el-alert v-if="!canEdit" title="您没有快登配置编辑权限，无法修改基础信息。" type="info" :closable="false" show-icon />
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'SettingsBasicInfo',
    data() {
        return {
            loading: false,
            saving: false,
            deleting: false,
            form: {
                site_name: ''
            },
            serverLogoUrl: '',
            pendingFile: null,
            pendingPreviewObjectUrl: '',
            previewBroken: false
        };
    },
    computed: {
        canEdit() {
            var user = this.$store.getters.currentUser;

            if (!user) {
                return false;
            }

            if (user.is_super_admin) {
                return true;
            }

            var permissions = user.permissions || [];

            return permissions.indexOf('quick_link.edit') >= 0;
        },
        pendingFileName() {
            return this.pendingFile ? this.pendingFile.name : '';
        },
        hasLogoOnServer() {
            return !!this.serverLogoUrl;
        },
        previewUrl() {
            if (this.previewBroken) {
                return '';
            }

            if (this.pendingPreviewObjectUrl) {
                return this.pendingPreviewObjectUrl;
            }

            return this.serverLogoUrl || '';
        }
    },
    watch: {
        pendingFile: function (file) {
            if (this.pendingPreviewObjectUrl) {
                window.URL.revokeObjectURL(this.pendingPreviewObjectUrl);
                this.pendingPreviewObjectUrl = '';
            }

            if (file) {
                this.pendingPreviewObjectUrl = window.URL.createObjectURL(file);
            }
        }
    },
    created() {
        this.fetchBranding();
    },
    beforeDestroy() {
        if (this.pendingPreviewObjectUrl) {
            window.URL.revokeObjectURL(this.pendingPreviewObjectUrl);
        }
    },
    methods: {
        onImgError() {
            this.previewBroken = true;
        },
        onFileChange(event) {
            var files = event.target.files;
            this.previewBroken = false;
            this.pendingFile = files && files.length ? files[0] : null;

            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        fetchBranding() {
            var _this = this;
            this.loading = true;

            window.axios.get('/branding').then(function (response) {
                var data = response.data.data || {};
                _this.serverLogoUrl = data.logo_url || '';
                _this.form.site_name = data.site_name || '';
                _this.previewBroken = false;
            }).catch(function () {
                _this.$message.error('加载基础信息失败');
            }).finally(function () {
                _this.loading = false;
            });
        },
        handleSave() {
            if (!this.canEdit) {
                return;
            }

            var _this = this;
            var formData = new FormData();

            formData.append('site_name', this.form.site_name || '');

            if (this.pendingFile) {
                formData.append('logo', this.pendingFile);
            }

            this.saving = true;

            window.axios.post('/branding', formData).then(function (response) {
                _this.$message.success('保存成功');
                _this.pendingFile = null;
                var data = response.data.data || {};
                _this.serverLogoUrl = data.logo_url || '';
                _this.form.site_name = data.site_name || '';
                _this.$store.dispatch('fetchBranding');
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        },
        handleDeleteLogo() {
            if (!this.canEdit) {
                return;
            }

            var _this = this;

            if (!this.hasLogoOnServer && !this.pendingFile) {
                return;
            }

            if (this.pendingFile && !this.hasLogoOnServer) {
                this.pendingFile = null;
                this.$message.success('已取消待上传文件');

                return;
            }

            this.$confirm('确定删除已保存的 LOGO？', '提示', {
                type: 'warning'
            }).then(function () {
                _this.deleting = true;

                return window.axios.delete('/branding/logo');
            }).then(function (response) {
                _this.$message.success('已删除 LOGO');
                _this.pendingFile = null;
                var data = response.data.data || {};
                _this.serverLogoUrl = data.logo_url || '';
                _this.$store.dispatch('fetchBranding');
            }).catch(function (err) {
                if (err && err !== 'cancel') {
                    _this.$message.error('删除失败');
                }
            }).finally(function () {
                _this.deleting = false;
            });
        }
    }
};
</script>

<style scoped>
.settings-basic-info-page {
    padding: 0;
}

.settings-basic-info-page__card {
    max-width: 620px;
}

.settings-basic-info-page__input-name {
    max-width: 420px;
}

.settings-basic-info-page__preview-wrap {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    background: #f8faff;
    display: inline-block;
}

.settings-basic-info-page__preview {
    display: block;
    max-width: 240px;
    max-height: 80px;
    object-fit: contain;
}

.settings-basic-info-page__no-logo {
    color: #909399;
    font-size: 13px;
}

.settings-basic-info-page__pending {
    margin-top: 8px;
    font-size: 12px;
    color: #606266;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsBasicInfo.vue